import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import cn from 'classnames';
import common from "../../common.module.scss"
import style from "../OrderHistory.module.scss"
import styles from "./OrderHistoryMobile.module.scss";
import { numberToFinanceFormat } from '../../../../../utils';
import { CURRENCIES, ORDER_STATUSES_DATA } from '../../../../../mock';
import BallIcon from '../../../../shared/icons/BallIcon';
import LogoIcon from '../../../../shared/icons/LogoIcon';
import LupeIcon from '../../../../shared/icons/LupeIcon';
import UsersIcon from '../../../../shared/icons/UsersIcon';
import OrdersIcon from '../../../../shared/icons/OrdersIcon';
import UncheckCircleIcon from '../../../../shared/icons/UncheckCircleIcon';
import OrdersInfoDirections from '../OrdersInfoDirections';
import OrdersInfoCargo from '../OrdersInfoCargo';
import YandexMap from '../YandexMap';
import OrdersDriverInfo from '../OrdersDriverInfo';
import ListDocsOrder from '../ListDocsOrder';
import ListFilesOrder from '../ListFilesOrder';
import OrdersInfoAddressList from '../OrdersInfoAddressList';
import ArrowBackIcon from '../../../../shared/icons/ArrowBackIcon';
import CustomButton from '../../../../custom/custom-button/CustomButton';
import { File } from '../../../../../services';
import ConfirmModal from '../../../../shared/ConfirmModal/ConfirmModal';

const OrderHistoryMobile = ({
    item,
    onClose,
    statusHistory,
    recipientName,
    senderName,
    cargoDetails,
    cityFrom,
    cityTo,
    routeData,
    isLoadingMap,
    routeStartCity,
    coordinateTruck,
    bookingDate,
    driverPhotos,
  listDocDriver,
  listFilesOrder,
  refreshDocuments
}) => {
    const { t } = useTranslation();
    const [isLoadingZip, setIsLoadingZip] = useState(false);
    const [showConfirmDownloadModal, setShowConfirmDownloadModal] = useState(false);
    const allowedStatusesForDocs = [
      'awaitingoffer',
      'assigned',
      'assignedexecutor',
      'confirmed',
      'headingtoloading',
      'processloadingcargo',
      'onthetrip',
      'processunloadingcargo',
      'unloadingcargomoderation',
      'completedbyexecutor',
    ];

    const getIconColor = (status, step) => {
        const rejectedStatuses = ['rejected', 'canceled', 'rejectedloadingcargomoderation', 'rejectedunloadingcargomoderation'];
        const currentStep = {
            moderation: 1,
            awaitingpayment: 1,
            rejected: 1,
            assigned: 1,
            // canceled: 1,
            published: 2,
            booked: 3,
            confirmed: 3,
            processloadingcargo: 3,
            loadingcargomoderation: 3,
            waitstarttrip: 3,
            rejectedloadingcargomoderation: 3,
            onthetrip: 4,
            processunloadingcargo: 4,
            unloadingcargomoderation: 4,
            rejectedunloadingcargomoderation: 4,
            completed: 5
        };

        if (rejectedStatuses.includes(status) && step === currentStep[status]) {
            return { backgroundColor: '#C84620', iconColor: '#FFF', IconType: 2 };
        } else if (step <= currentStep[status]) {
            return { backgroundColor: '#212121', iconColor: '#FFF', IconType: 2 };
        } else {
            return { backgroundColor: '#F0F0F0', iconColor: '#212121', IconType: 1 };
        }
    };

    const renderIcon = (step) => {
        const status = item?.status;
        
        const { backgroundColor, iconColor, IconType } = getIconColor(status, step);

        switch (step) {
            case 1:
                return <>
                    <div className={style.history_icons_circle} style={{ backgroundColor }}>
                        <div className={style.history_icons_icon}>
                            <LogoIcon type={IconType} color={iconColor} width='32px' height='32px' />
                        </div>
                    </div>

                </>
            case 2:
                return <>
                    <div className={style.history_icons_line} style={{ backgroundColor }}></div>
                    <div className={style.history_icons_circle} style={{ backgroundColor }}>
                        <div className={style.history_icons_icon}>
                            <LupeIcon color={iconColor} />
                        </div>
                    </div>
                </>
            case 3:
                return <>
                    <div className={style.history_icons_line} style={{ backgroundColor }}></div>
                    <div className={style.history_icons_circle} style={{ backgroundColor }}>
                        <div className={style.history_icons_icon}>
                            <UsersIcon color={iconColor} />
                        </div>
                    </div>
                </>
            case 4:
                return <>
                    <div className={style.history_icons_line} style={{ backgroundColor }}></div>
                    <div className={style.history_icons_circle} style={{ backgroundColor }}>
                        <div className={style.history_icons_icon}>
                            <OrdersIcon color={iconColor} />
                        </div>
                    </div>
                </>
            case 5:
                return <>
                    <div className={style.history_icons_line} style={{ backgroundColor }}></div>
                    <div className={style.history_icons_circle} style={{ backgroundColor }}>
                        <div className={style.history_icons_icon}>
                            <UncheckCircleIcon color={iconColor} />
                        </div>
                    </div>
                </>
            default:
                return null;
        }
    };

    const setSummary = (status) => {
        // Using keys defined in ru.json
        switch (status) {
            case 'moderation': return t('orderInfo.orderHistory.summaryModeration');
            case 'published': return "";
            case 'waitstarttrip': return ""; // No text provided for these statuses
            case 'awaitingpayment': return ""; // No text provided for these statuses
            case 'waitingforcompletion': return ""; // No text provided
            case 'inprocess': return ""; // No text provided
            case 'onthetrip': return t('orderInfo.orderHistory.summaryOnTheTrip');
            case 'waitloadingcargo': return t('orderInfo.orderHistory.summaryWaitLoading');
            case 'completed': return ""; // No text provided
            case 'rejectedunloadingcargomoderation': return ""; // No text provided
            case 'unloadingcargomoderation': return ""; // No text provided
            case 'processunloadingcargo': return t('orderInfo.orderHistory.summaryProcessUnloading');
            case 'processloadingcargo': return t('orderInfo.orderHistory.summaryProcessLoading'); // Corrected typo
            case 'unloadingcargo': return ""; // No text provided
            case 'loadingcargo': return t('orderInfo.orderHistory.summaryLoadingCargo');
            case 'waitcompletion': return ""; // No text provided
            case 'canceled': return ""; // No text provided
            case 'booked': return `${item?.driverSurname} ${item?.driverName}`;
            case 'rejected': return
            case 'confirmed': return

            default: return '';
        }
    };

    const handleDownloadButtonClick = () => {
      setShowConfirmDownloadModal(true);
    };

    const handleConfirmDownload = () => {
      if (!item?.id) {
        toast.error(t('orderInfo.genericError'));
        setShowConfirmDownloadModal(false);
        return;
      }

      setIsLoadingZip(true);
      File.downloadZipByOrderId(item.id)
        .then((response) => {
          const fileBlob = new Blob([response.data], {
            type: 'application/zip',
          });

          const fileURL = URL.createObjectURL(fileBlob);
          const downloadElement = document.createElement("a");
          downloadElement.href = fileURL;
          downloadElement.download = `order_${item.id}_documents.zip`;
          downloadElement.click();
          URL.revokeObjectURL(fileURL);
          setShowConfirmDownloadModal(false);
        })
        .catch((error) => {
          console.log("Произошла ошибка при скачивании архива", error);
          toast.error(t('orderInfo.genericError'));
        })
        .finally(() => {
          setIsLoadingZip(false);
        });
    };

    const handleCancelDownload = () => {
      setShowConfirmDownloadModal(false);
    };

    return (
      <div className={cn("modal-overlay", styles.mobile__wrapper)}>
        <div className={styles.mobile__modal}>
          <div className={styles.topbar}>
            <ArrowBackIcon style={{ cursor: "pointer" }} fill="#6D7885" onClick={onClose} />

            <div className={styles.topbar__content}>
              <div className={style.history_title}>{t("orderInfo.orderHistory.title")}</div>
              <div
                className={style.history_status_title}
                style={{ color: ORDER_STATUSES_DATA(t)[item?.status]?.color }}
              >
                <BallIcon fill={ORDER_STATUSES_DATA(t)[item?.status]?.color} />
                {ORDER_STATUSES_DATA(t)[item?.status]?.title || item?.status}
              </div>
            </div>
          </div>

          <div className={styles.mobile__main}>
            <div className={style.history_content}>
              <div className={styles.mobile__icons}>
                {renderIcon(1)}
                {renderIcon(2)}
                {renderIcon(3)}
                {renderIcon(4)}
                {renderIcon(5)}
              </div>

              <div className={styles.mobile__maps}>
                <YandexMap
                  item={item}
                  addressList={item?.addressList}
                  cityFrom={cityFrom}
                  cityTo={cityTo}
                  routeData={routeData}
                  isLoadingMap={isLoadingMap}
                  routeStartCity={routeStartCity}
                  coordinateTruck={coordinateTruck}
                />
              </div>

              <div className={style.history_details}>
                <div className={style.history_details_line}>
                  <BallIcon fill="#6D7885" />
                  <div className={style.history_details_border}></div>
                  <BallIcon fill="#6D7885" />
                </div>
                <div className={style.history_details_info}>
                  {statusHistory && statusHistory.map((status, index) => (
                    <div key={index} className={style.history_details_item}>
                      <div className={style.history_details_title}>
                        {t(`mockData.orderStatuses.${status.statusCode?.toLowerCase()}`) || status.statusName || status.statusCode}
                        {status.statusCode === 'assigned' ? <span> — {item?.expeditorName}</span> : ''}
                      </div>
                      <div className={style.history_details_summary}>
                        {status.createdAtStr}
                        {status.moderator && <span> — {status.moderator}</span>}
                        {status.addressName && <span> — {status?.addressName}</span>}
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {listFilesOrder && listFilesOrder.length > 0 && allowedStatusesForDocs.includes(item?.status?.toLowerCase()) ? (
                <ListFilesOrder
                  documents={listFilesOrder}
                  orderStatus={item?.status}
                  refreshDocuments={refreshDocuments}
                />
              ) : null}
              {(driverPhotos && driverPhotos.length > 0) && !listFilesOrder?.length ? (
                <ListDocsOrder documents={driverPhotos} orderData={item} />
              ) : null}

              {((driverPhotos && driverPhotos.length > 0) ||
                (listFilesOrder &&
                  listFilesOrder.length > 0 &&
                  allowedStatusesForDocs.includes(item?.status?.toLowerCase()))) && (
                <CustomButton
                  text={t("orderInfo.orderHistory.downloadAll")}
                  onClick={handleDownloadButtonClick}
                  isFall
                  disabled={isLoadingZip}
                  isLoading={isLoadingZip}
                />
              )}

              {item && item.addressList.length < 1 ? (
                <OrdersInfoDirections
                  item={item}
                  senderName={senderName}
                  recipientName={recipientName}
                />
              ) : (
                <OrdersInfoAddressList order={item} addressList={item?.addressList} />
              )}

              <div className={cn(common.basic_wrapper, styles.mobile__basic)}>
                <div className={common.basic_numbers}>
                  <span className={common.basic_price}>
                    {numberToFinanceFormat(item?.price)} {CURRENCIES[item?.currency || "KZT"]?.symbol || ""}
                  </span>
                  <div className={common.basic_lower_part}>
                    <span className={common.basic_number}> №{item?.number}</span>
                    {item?.referenceNumber && <span className={common.basic_number}>- {item?.referenceNumber}</span>}
                  </div>
                </div>
                <div className={common.basic_distance}>
                  {numberToFinanceFormat(item?.distance)}{t("analytics.distance_metric")}
                </div>
              </div>

              {item && (item.drivers?.length > 0 || item.driverId) && (
                <OrdersDriverInfo
                  item={item}
                  drivers={item.drivers || []}
                  driverId={item.driverId}
                  recipientName={recipientName}
                  senderName={senderName}
                  bookingDate={bookingDate}
                  listDocDriver={listDocDriver}
                />
              )}

              <OrdersInfoCargo item={cargoDetails} order={item} />
            </div>
            <div className={style.history_maps}>
              {/* <YandexMap
                item={item}
                addressList={item?.addressList}
                cityFrom={cityFrom}
                cityTo={cityTo}
                routeData={routeData}
                isLoadingMap={isLoadingMap}
                routeStartCity={routeStartCity}
                coordinateTruck={coordinateTruck}
              /> */}
            </div>
          </div>
        </div>
        <button className={style.history_btn}></button>

        <ConfirmModal
          isOpen={showConfirmDownloadModal}
          title={t("orderInfo.orderHistory.downloadAllTitle")}
          message={t("orderInfo.orderHistory.downloadAllMessage")}
          confirmText={t("common.confirm")}
          cancelText={t("common.cancel")}
          onConfirm={handleConfirmDownload}
          onCancel={handleCancelDownload}
          isLoading={isLoadingZip}
        />
      </div>
    );
};

export default OrderHistoryMobile;
